import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';

import { Props } from './types';

export const Renderer: ComponentType<Props> & LoadableComponent = Loadable<Props, any>({
	loader: () => import(/* webpackChunkName: "renderer" */ './Renderer'),
	loading: () => null,
});
